import { ReactElement, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { showModal } from 'modules/main/store/ducks/modal';
import { subscribeToSubsite } from 'modules/main/store/ducks/subscribedSubsites';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { getParam } from 'utils/url';

type OwnProps = {
  subsiteId: string;
  render: (arg0: {
    subscribe: () => void;
    isSubscribed: boolean;
    submitting: boolean;
  }) => ReactElement;
};
type Props = OwnProps;

const SubscribeToSubsiteContainer = ({ subsiteId, render }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { subscribedSubsites } = useSelector((state) => ({
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    subscribedSubsites: state.subscribedSubsites,
  }));
  const isSubscribed = subscribedSubsites.subsiteIds.includes(subsiteId);
  const [submitting, setSubmitting] = useState(false);
  const { user, isUserLoaded } = useUserEnvironment();
  const subscribe = useCallback(() => {
    if (user) {
      setSubmitting(true);
      // @ts-expect-error TS(2345): Argument of type '(dispatch: Dispatch<MainStoreSub... Remove this comment to see the full error message
      dispatch(subscribeToSubsite(subsiteId)).then(() => {
        setSubmitting(false);
      });
    } else {
      dispatch(showModal('EMAIL_SIGNUP', { subscribedSubsite: subsiteId }));
    }
  }, [user, dispatch, subsiteId]);
  useEffect(() => {
    if (isUserLoaded) {
      const initSubscribe = getParam(location, 'subscribe');

      if (initSubscribe) {
        subscribe();
      }
    }
  }, [isUserLoaded, location, subscribe]);
  return render({
    subscribe,
    isSubscribed,
    submitting,
  });
};

// eslint-disable-next-line import/no-default-export
export default SubscribeToSubsiteContainer;
